$(document).ready(function(){
  $(document).on('click', '.btn-toggle-password', function(){
    var passwordInput = $(this).prev('input');
    $(this).toggleClass('active');
    if(passwordInput.attr('type') === 'password') {
      passwordInput.attr('type', 'text');
    } else {
      passwordInput.attr('type', 'password');
    }
  })
})